// Auto-generated mapping for all Python components

import AUC_ROC_Curve from "./python_all_components/AUC_ROC_Curve.jsx";
import Bootstrap_Aggregation from "./python_all_components/Bootstrap_Aggregation.jsx";
import Categorical_Data from "./python_all_components/Categorical_Data.jsx";
import Confusion_Matrix from "./python_all_components/Confusion_Matrix.jsx";
import Cross_Validation from "./python_all_components/Cross_Validation.jsx";
import Data_Distribution from "./python_all_components/Data_Distribution.jsx";
import Decision_Tree from "./python_all_components/Decision_Tree.jsx";
import Django_Tutorial from "./python_all_components/Django_Tutorial.jsx";
import Getting_Started from "./python_all_components/Getting_Started.jsx";
import Grid_Search from "./python_all_components/Grid_Search.jsx";
import Hierarchical_Clustering from "./python_all_components/Hierarchical_Clustering.jsx";
import Kmeans from "./python_all_components/Kmeans.jsx";
import Knearest_neighbors from "./python_all_components/Knearest_neighbors.jsx";
import Linear_Regression from "./python_all_components/Linear_Regression.jsx";
import Logistic_Regression from "./python_all_components/Logistic_Regression.jsx";
import Matplotlib_Bars from "./python_all_components/Matplotlib_Bars.jsx";
import Matplotlib_Get_Started from "./python_all_components/Matplotlib_Get_Started.jsx";
import Matplotlib_Grid from "./python_all_components/Matplotlib_Grid.jsx";
import Matplotlib_Histograms from "./python_all_components/Matplotlib_Histograms.jsx";
import Matplotlib_Intro from "./python_all_components/Matplotlib_Intro.jsx";
import Matplotlib_Labels from "./python_all_components/Matplotlib_Labels.jsx";
import Matplotlib_Line from "./python_all_components/Matplotlib_Line.jsx";
import Matplotlib_Markers from "./python_all_components/Matplotlib_Markers.jsx";
import Matplotlib_Pie_Charts from "./python_all_components/Matplotlib_Pie_Charts.jsx";
import Matplotlib_Plotting from "./python_all_components/Matplotlib_Plotting.jsx";
import Matplotlib_Pyplot from "./python_all_components/Matplotlib_Pyplot.jsx";
import Matplotlib_Scatter from "./python_all_components/Matplotlib_Scatter.jsx";
import Matplotlib_Subplot from "./python_all_components/Matplotlib_Subplot.jsx";
import Mean_Median_Mode from "./python_all_components/Mean_Median_Mode.jsx";
import Multiple_Regression from "./python_all_components/Multiple_Regression.jsx";
import Normal_Data_Distribution from "./python_all_components/Normal_Data_Distribution.jsx";
import NumPy_Tutorial from "./python_all_components/NumPy_Tutorial.jsx";
import Pandas_Tutorial from "./python_all_components/Pandas_Tutorial.jsx";
import Percentile from "./python_all_components/Percentile.jsx";
import Polynomial_Regression from "./python_all_components/Polynomial_Regression.jsx";
import Python_Access_Items from "./python_all_components/Python_Access_Items.jsx";
import Python_Access_List_Items from "./python_all_components/Python_Access_List_Items.jsx";
import Python_Access_Set_Items from "./python_all_components/Python_Access_Set_Items.jsx";
import Python_Access_Tuples from "./python_all_components/Python_Access_Tuples.jsx";
import Python_Add_Items from "./python_all_components/Python_Add_Items.jsx";
import Python_Add_List_Items from "./python_all_components/Python_Add_List_Items.jsx";
import Python_Add_Set_Items from "./python_all_components/Python_Add_Set_Items.jsx";
import Python_Arrays from "./python_all_components/Python_Arrays.jsx";
import Python_Assign_Multiple_Values from "./python_all_components/Python_Assign_Multiple_Values.jsx";
import Python_Booleans from "./python_all_components/Python_Booleans.jsx";
import Python_Casting from "./python_all_components/Python_Casting.jsx";
import Python_Change_Items from "./python_all_components/Python_Change_Items.jsx";
import Python_Change_List_Items from "./python_all_components/Python_Change_List_Items.jsx";
import Python_Classes_Objects from "./python_all_components/Python_Classes_Objects.jsx";
import Python_Comments from "./python_all_components/Python_Comments.jsx";
import Python_Concatenate_Strings from "./python_all_components/Python_Concatenate_Strings.jsx";
import Python_Copy_Dictionaries from "./python_all_components/Python_Copy_Dictionaries.jsx";
import Python_Copy_Lists from "./python_all_components/Python_Copy_Lists.jsx";
import Python_Data_Types from "./python_all_components/Python_Data_Types.jsx";
import Python_Dates from "./python_all_components/Python_Dates.jsx";
import Python_Delete_Files from "./python_all_components/Python_Delete_Files.jsx";
import Python_Dictionaries from "./python_all_components/Python_Dictionaries.jsx";
import Python_Dictionary_Exercises from "./python_all_components/Python_Dictionary_Exercises.jsx";
import Python_Dictionary_Methods from "./python_all_components/Python_Dictionary_Methods.jsx";
import Python_Escape_Characters from "./python_all_components/Python_Escape_Characters.jsx";
import Python_File_Handling from "./python_all_components/Python_File_Handling.jsx";
import Python_Format_Strings from "./python_all_components/Python_Format_Strings.jsx";
import Python_For_Loops from "./python_all_components/Python_For_Loops.jsx";
import Python_Functions from "./python_all_components/Python_Functions.jsx";
import Python_Get_Started from "./python_all_components/Python_Get_Started.jsx";
import Python_Global_Variables from "./python_all_components/Python_Global_Variables.jsx";
import Python_HOME from "./python_all_components/Python_HOME.jsx";
import Python_IfElse from "./python_all_components/Python_IfElse.jsx";
import Python_Inheritance from "./python_all_components/Python_Inheritance.jsx";
import Python_Intro from "./python_all_components/Python_Intro.jsx";
import Python_Iterators from "./python_all_components/Python_Iterators.jsx";
import Python_Join_Lists from "./python_all_components/Python_Join_Lists.jsx";
import Python_Join_Sets from "./python_all_components/Python_Join_Sets.jsx";
import Python_Join_Tuples from "./python_all_components/Python_Join_Tuples.jsx";
import Python_JSON from "./python_all_components/Python_JSON.jsx";
import Python_Lambda from "./python_all_components/Python_Lambda.jsx";
import Python_Lists from "./python_all_components/Python_Lists.jsx";
import Python_List_Comprehension from "./python_all_components/Python_List_Comprehension.jsx";
import Python_List_Exercises from "./python_all_components/Python_List_Exercises.jsx";
import Python_List_Methods from "./python_all_components/Python_List_Methods.jsx";
import Python_Loop_Dictionaries from "./python_all_components/Python_Loop_Dictionaries.jsx";
import Python_Loop_Lists from "./python_all_components/Python_Loop_Lists.jsx";
import Python_Loop_Sets from "./python_all_components/Python_Loop_Sets.jsx";
import Python_Loop_Tuples from "./python_all_components/Python_Loop_Tuples.jsx";
import Python_Match from "./python_all_components/Python_Match.jsx";
import Python_Math from "./python_all_components/Python_Math.jsx";
import Python_Modify_Strings from "./python_all_components/Python_Modify_Strings.jsx";
import Python_Modules from "./python_all_components/Python_Modules.jsx";
import Python_Nested_Dictionaries from "./python_all_components/Python_Nested_Dictionaries.jsx";
import Python_Numbers from "./python_all_components/Python_Numbers.jsx";
import Python_OOP from "./python_all_components/Python_OOP.jsx";
import Python_Operators from "./python_all_components/Python_Operators.jsx";
import Python_Output_Variables from "./python_all_components/Python_Output_Variables.jsx";
import Python_PIP from "./python_all_components/Python_PIP.jsx";
import Python_Polymorphism from "./python_all_components/Python_Polymorphism.jsx";
import Python_Read_Files from "./python_all_components/Python_Read_Files.jsx";
import Python_RegEx from "./python_all_components/Python_RegEx.jsx";
import Python_Remove_Items from "./python_all_components/Python_Remove_Items.jsx";
import Python_Remove_List_Items from "./python_all_components/Python_Remove_List_Items.jsx";
import Python_Remove_Set_Items from "./python_all_components/Python_Remove_Set_Items.jsx";
import Python_Scope from "./python_all_components/Python_Scope.jsx";
import Python_Sets from "./python_all_components/Python_Sets.jsx";
import Python_Set_Exercises from "./python_all_components/Python_Set_Exercises.jsx";
import Python_Set_Methods from "./python_all_components/Python_Set_Methods.jsx";
import Python_Slicing_Strings from "./python_all_components/Python_Slicing_Strings.jsx";
import Python_Sort_Lists from "./python_all_components/Python_Sort_Lists.jsx";
import Python_Strings from "./python_all_components/Python_Strings.jsx";
import Python_String_Exercises from "./python_all_components/Python_String_Exercises.jsx";
import Python_String_Formatting from "./python_all_components/Python_String_Formatting.jsx";
import Python_String_Methods from "./python_all_components/Python_String_Methods.jsx";
import Python_Syntax from "./python_all_components/Python_Syntax.jsx";
import Python_TryExcept from "./python_all_components/Python_TryExcept.jsx";
import Python_Tuples from "./python_all_components/Python_Tuples.jsx";
import Python_Tuple_Exercises from "./python_all_components/Python_Tuple_Exercises.jsx";
import Python_Tuple_Methods from "./python_all_components/Python_Tuple_Methods.jsx";
import Python_Unpack_Tuples from "./python_all_components/Python_Unpack_Tuples.jsx";
import Python_Update_Tuples from "./python_all_components/Python_Update_Tuples.jsx";
import Python_User_Input from "./python_all_components/Python_User_Input.jsx";
import Python_Variables from "./python_all_components/Python_Variables.jsx";
import Python_Variable_Exercises from "./python_all_components/Python_Variable_Exercises.jsx";
import Python_Variable_Names from "./python_all_components/Python_Variable_Names.jsx";
import Python_VirtualEnv from "./python_all_components/Python_VirtualEnv.jsx";
import Python_While_Loops from "./python_all_components/Python_While_Loops.jsx";
import Python_Write_Create_Files from "./python_all_components/Python_Write_Create_Files.jsx";
import Scale from "./python_all_components/Scale.jsx";
import Scatter_Plot from "./python_all_components/Scatter_Plot.jsx";
import SciPy_Tutorial from "./python_all_components/SciPy_Tutorial.jsx";
import Standard_Deviation from "./python_all_components/Standard_Deviation.jsx";
import Train_Test from "./python_all_components/Train_Test.jsx";

const AllPythonComponents = {
  "<AUC_ROC_Curve />": AUC_ROC_Curve,
  "<Bootstrap_Aggregation />": Bootstrap_Aggregation,
  "<Categorical_Data />": Categorical_Data,
  "<Confusion_Matrix />": Confusion_Matrix,
  "<Cross_Validation />": Cross_Validation,
  "<Data_Distribution />": Data_Distribution,
  "<Decision_Tree />": Decision_Tree,
  "<Django_Tutorial />": Django_Tutorial,
  "<Getting_Started />": Getting_Started,
  "<Grid_Search />": Grid_Search,
  "<Hierarchical_Clustering />": Hierarchical_Clustering,
  "<Kmeans />": Kmeans,
  "<Knearest_neighbors />": Knearest_neighbors,
  "<Linear_Regression />": Linear_Regression,
  "<Logistic_Regression />": Logistic_Regression,
  "<Matplotlib_Bars />": Matplotlib_Bars,
  "<Matplotlib_Get_Started />": Matplotlib_Get_Started,
  "<Matplotlib_Grid />": Matplotlib_Grid,
  "<Matplotlib_Histograms />": Matplotlib_Histograms,
  "<Matplotlib_Intro />": Matplotlib_Intro,
  "<Matplotlib_Labels />": Matplotlib_Labels,
  "<Matplotlib_Line />": Matplotlib_Line,
  "<Matplotlib_Markers />": Matplotlib_Markers,
  "<Matplotlib_Pie_Charts />": Matplotlib_Pie_Charts,
  "<Matplotlib_Plotting />": Matplotlib_Plotting,
  "<Matplotlib_Pyplot />": Matplotlib_Pyplot,
  "<Matplotlib_Scatter />": Matplotlib_Scatter,
  "<Matplotlib_Subplot />": Matplotlib_Subplot,
  "<Mean_Median_Mode />": Mean_Median_Mode,
  "<Multiple_Regression />": Multiple_Regression,
  "<Normal_Data_Distribution />": Normal_Data_Distribution,
  "<NumPy_Tutorial />": NumPy_Tutorial,
  "<Pandas_Tutorial />": Pandas_Tutorial,
  "<Percentile />": Percentile,
  "<Polynomial_Regression />": Polynomial_Regression,
  "<Python_Access_Items />": Python_Access_Items,
  "<Python_Access_List_Items />": Python_Access_List_Items,
  "<Python_Access_Set_Items />": Python_Access_Set_Items,
  "<Python_Access_Tuples />": Python_Access_Tuples,
  "<Python_Add_Items />": Python_Add_Items,
  "<Python_Add_List_Items />": Python_Add_List_Items,
  "<Python_Add_Set_Items />": Python_Add_Set_Items,
  "<Python_Arrays />": Python_Arrays,
  "<Python_Assign_Multiple_Values />": Python_Assign_Multiple_Values,
  "<Python_Booleans />": Python_Booleans,
  "<Python_Casting />": Python_Casting,
  "<Python_Change_Items />": Python_Change_Items,
  "<Python_Change_List_Items />": Python_Change_List_Items,
  "<Python_Classes_Objects />": Python_Classes_Objects,
  "<Python_Comments />": Python_Comments,
  "<Python_Concatenate_Strings />": Python_Concatenate_Strings,
  "<Python_Copy_Dictionaries />": Python_Copy_Dictionaries,
  "<Python_Copy_Lists />": Python_Copy_Lists,
  "<Python_Data_Types />": Python_Data_Types,
  "<Python_Dates />": Python_Dates,
  "<Python_Delete_Files />": Python_Delete_Files,
  "<Python_Dictionaries />": Python_Dictionaries,
  "<Python_Dictionary_Exercises />": Python_Dictionary_Exercises,
  "<Python_Dictionary_Methods />": Python_Dictionary_Methods,
  "<Python_Escape_Characters />": Python_Escape_Characters,
  "<Python_File_Handling />": Python_File_Handling,
  "<Python_Format_Strings />": Python_Format_Strings,
  "<Python_For_Loops />": Python_For_Loops,
  "<Python_Functions />": Python_Functions,
  "<Python_Get_Started />": Python_Get_Started,
  "<Python_Global_Variables />": Python_Global_Variables,
  "<Python_HOME />": Python_HOME,
  "<Python_IfElse />": Python_IfElse,
  "<Python_Inheritance />": Python_Inheritance,
  "<Python_Intro />": Python_Intro,
  "<Python_Iterators />": Python_Iterators,
  "<Python_Join_Lists />": Python_Join_Lists,
  "<Python_Join_Sets />": Python_Join_Sets,
  "<Python_Join_Tuples />": Python_Join_Tuples,
  "<Python_JSON />": Python_JSON,
  "<Python_Lambda />": Python_Lambda,
  "<Python_Lists />": Python_Lists,
  "<Python_List_Comprehension />": Python_List_Comprehension,
  "<Python_List_Exercises />": Python_List_Exercises,
  "<Python_List_Methods />": Python_List_Methods,
  "<Python_Loop_Dictionaries />": Python_Loop_Dictionaries,
  "<Python_Loop_Lists />": Python_Loop_Lists,
  "<Python_Loop_Sets />": Python_Loop_Sets,
  "<Python_Loop_Tuples />": Python_Loop_Tuples,
  "<Python_Match />": Python_Match,
  "<Python_Math />": Python_Math,
  "<Python_Modify_Strings />": Python_Modify_Strings,
  "<Python_Modules />": Python_Modules,
  "<Python_Nested_Dictionaries />": Python_Nested_Dictionaries,
  "<Python_Numbers />": Python_Numbers,
  "<Python_OOP />": Python_OOP,
  "<Python_Operators />": Python_Operators,
  "<Python_Output_Variables />": Python_Output_Variables,
  "<Python_PIP />": Python_PIP,
  "<Python_Polymorphism />": Python_Polymorphism,
  "<Python_Read_Files />": Python_Read_Files,
  "<Python_RegEx />": Python_RegEx,
  "<Python_Remove_Items />": Python_Remove_Items,
  "<Python_Remove_List_Items />": Python_Remove_List_Items,
  "<Python_Remove_Set_Items />": Python_Remove_Set_Items,
  "<Python_Scope />": Python_Scope,
  "<Python_Sets />": Python_Sets,
  "<Python_Set_Exercises />": Python_Set_Exercises,
  "<Python_Set_Methods />": Python_Set_Methods,
  "<Python_Slicing_Strings />": Python_Slicing_Strings,
  "<Python_Sort_Lists />": Python_Sort_Lists,
  "<Python_Strings />": Python_Strings,
  "<Python_String_Exercises />": Python_String_Exercises,
  "<Python_String_Formatting />": Python_String_Formatting,
  "<Python_String_Methods />": Python_String_Methods,
  "<Python_Syntax />": Python_Syntax,
  "<Python_TryExcept />": Python_TryExcept,
  "<Python_Tuples />": Python_Tuples,
  "<Python_Tuple_Exercises />": Python_Tuple_Exercises,
  "<Python_Tuple_Methods />": Python_Tuple_Methods,
  "<Python_Unpack_Tuples />": Python_Unpack_Tuples,
  "<Python_Update_Tuples />": Python_Update_Tuples,
  "<Python_User_Input />": Python_User_Input,
  "<Python_Variables />": Python_Variables,
  "<Python_Variable_Exercises />": Python_Variable_Exercises,
  "<Python_Variable_Names />": Python_Variable_Names,
  "<Python_VirtualEnv />": Python_VirtualEnv,
  "<Python_While_Loops />": Python_While_Loops,
  "<Python_Write_Create_Files />": Python_Write_Create_Files,
  "<Scale />": Scale,
  "<Scatter_Plot />": Scatter_Plot,
  "<SciPy_Tutorial />": SciPy_Tutorial,
  "<Standard_Deviation />": Standard_Deviation,
  "<Train_Test />": Train_Test,
};

export default AllPythonComponents;
